import React, { useState } from "react";
import CustomField from "./common/customField";
import { onlyNumber } from "../helpers/formats";

const DateSelector = ({ handleAddDate, handleShowPopup }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [occurrence, setOccurrence] = useState("");
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { id, value } = e.target;
    if (id === "startDate") {
      setStartDate(value);
    } else if (id === "occurrence") {
      setOccurrence(value);
    } else {
      setEndDate(value);
    }
    // Clear errors when user types
    if (errors[id]) {
      setErrors((prev) => ({ ...prev, [id]: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!startDate) {
      newErrors.startDate = "Start date is required";
    }
    if (!endDate && !occurrence) {
      newErrors.endDate = "Either end date or occurrence is required";
      newErrors.occurrence = "Either end date or occurrence is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddButtonClick = () => {
    if (!validate()) return;

    handleAddDate(startDate, endDate, occurrence, startDate); // Added startDate as saleDate
    handleShowPopup();
    setStartDate("");
    setEndDate("");
    setOccurrence("");
  };

  return (
    <>
      <div className='mt-2 mb-2'>
        <CustomField
          type='date'
          id='startDate'
          name='startDate'
          label='Start Date'
          placeholder='Start Date'
          handleChange={handleChange}
          value={startDate}
          required
          error={errors.startDate}
        />
        <div className='mt-2 mb-2'>
          <CustomField
            type='date'
            id='endDate'
            name='endDate'
            label='End Date'
            placeholder='End Date'
            handleChange={handleChange}
            value={endDate}
            error={errors.endDate}
          />
        </div>
        <div className='text-center mt-2'> Or</div>

        <div className='mt-2'>
          <CustomField
            type='text'
            id='occurrence'
            name='occurrence'
            label='Occurrence'
            placeholder='Occurrence'
            handleChange={handleChange}
            value={occurrence}
            onKeyPress={onlyNumber}
            error={errors.occurrence}
          />
        </div>
      </div>
      <div className='flex justify-end'>
        <button
          className='py-2 px-2 bg-blue-600 hover:bg-blue-700 text-white mt-4 font-bold rounded'
          onClick={handleAddButtonClick}
        >
          Save
        </button>
      </div>
    </>
  );
};

export default DateSelector;
